import { __assign, __extends } from "tslib";
import React from 'react';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { PnmacParagraph, PnmacRadioButton, PnmacRadioButtonGroup, PnmacRowHeader, PnmacUIButton, PnmacMediaQuery, PnmacPaper, PnmacMeta } from 'pnmac-universal-components';
import styles from '../../styles/styles.js';
import { UPDATE_LOAN_PREF } from "../../redux/actions/actions.js";
import { SuccessMessage } from '../../components/SuccessMessage.js';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { textStyle } from "../../v2/theme";
import BannerView from "../../v2/BannerView";
import HtmlToNative from '../../HtmlToNative/index.js';
// First, define the enum mappings
var PreferenceTypes = {
  300043: 'AffiliateMktng',
  300044: 'NonAffiliateMktng'
};
var SelectionTypes = {
  300045: 'Yes',
  300046: 'No'
};
var PrivacyPreferences = /** @class */function (_super) {
  __extends(PrivacyPreferences, _super);
  function PrivacyPreferences(props) {
    var _this = this;
    var _a, _b, _c;
    _this = _super.call(this, props) || this;
    _this.changeValue = function (value, property) {
      var loanPreference = _this.state.loanPreference;
      var index = loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.findIndex(function (s) {
        return parseInt(s.preferenceTypeCode) == parseInt(value);
      });
      if (index > -1) {
        loanPreference[index].changed = true;
        loanPreference[index].preferenceCode = property;
      } else {
        var l = __assign({}, loanPreference[0]);
        l.preferenceCode = property;
        l.preferenceTypeCode = value;
        l.changed = true;
        loanPreference.push(l);
      }
      _this.setState({
        loanPreference: loanPreference,
        notchanged: false
      }, function () {
        return _this.props.dispatch({
          type: UPDATE_LOAN_PREF,
          selectedLoanPreference: loanPreference
        });
      });
    };
    _this.createChangeLog = function (current, previous) {
      if (!current || !previous) return [];
      var changes = [];
      current.forEach(function (currentItem) {
        var previousItem = previous.find(function (prev) {
          return prev.preferenceTypeCode === currentItem.preferenceTypeCode;
        });
        if (previousItem && previousItem.preferenceCode !== currentItem.preferenceCode) {
          var preferenceType = PreferenceTypes[currentItem.preferenceTypeCode];
          var previousSelection = SelectionTypes[previousItem.preferenceCode];
          var newSelection = SelectionTypes[currentItem.preferenceCode];
          changes.push({
            changeDescription: "".concat(preferenceType, ":").concat(previousSelection, "=>").concat(newSelection),
            preferenceTypeCode: currentItem.preferenceTypeCode,
            previousValue: previousItem.preferenceCode,
            newValue: currentItem.preferenceCode
          });
        }
      });
      // Create a combined log string
      var logString = 'AccSetting/PrivPrefs; ';
      var logString1 = changes.map(function (change) {
        return change.changeDescription;
      }).join(', ');
      logString += "".concat(logString1, "|Web");
      var returnVal = (changes === null || changes === void 0 ? void 0 : changes.length) > 0 ? {
        logString: logString,
        changes: changes
      } : {};
      return returnVal;
    };
    _this.state = {
      allowShareAff: false,
      allowShareNoneAff: false,
      loanPreference: (_a = props.layout) === null || _a === void 0 ? void 0 : _a.selectedLoanPreference,
      loanPreferencePrev: (_c = (_b = props.layout) === null || _b === void 0 ? void 0 : _b.selectedLoanPreference) === null || _c === void 0 ? void 0 : _c.map(function (item) {
        return __assign({}, item);
      }),
      confirmFinal: false,
      loading: false,
      notchanged: true
    };
    return _this;
  }
  PrivacyPreferences.getDerivedStateFromProps = function (props, state) {
    var _a, _b, _c, _d, _e;
    if (!state.loanPreference || ((_a = state.loanPreference) === null || _a === void 0 ? void 0 : _a.length) == 0 || (state === null || state === void 0 ? void 0 : state.loanPreference) != ((_b = props.layout) === null || _b === void 0 ? void 0 : _b.selectedLoanPreference)) {
      return __assign(__assign({}, state), {
        loanPreference: (_c = props.layout) === null || _c === void 0 ? void 0 : _c.selectedLoanPreference,
        loanPreferencePrev: (_e = (_d = props.layout) === null || _d === void 0 ? void 0 : _d.selectedLoanPreference) === null || _e === void 0 ? void 0 : _e.map(function (item) {
          return __assign({}, item);
        })
      });
    } else {
      return null;
    }
  };
  PrivacyPreferences.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations;
    var _b = this.state,
      loanPreference = _b.loanPreference,
      loanPreferencePrev = _b.loanPreferencePrev,
      notchanged = _b.notchanged,
      loading = _b.loading,
      confirmFinal = _b.confirmFinal;
    var selectedLoanNumber = layout.selectedLoanNumber;
    var affiliateMarketingPermission = (loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.find(function (s) {
      return s.preferenceTypeCode == 300043;
    })) || {};
    var nonAffiliateMarketingPermissions = (loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.find(function (s) {
      return s.preferenceTypeCode == 300044;
    })) || {};
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a;
      return (loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.length) > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "Privacy Preferences"
      }), /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, /*#__PURE__*/React.createElement("b", null, translations.Note, ":"), " ", translations.PrivacyPreferencesForLoan, " ", /*#__PURE__*/React.createElement("b", null, (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%"
        }
      }, confirmFinal ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false
          });
        },
        message: translations.PrivacyPreferencesSuccessMessage
      }) : null, /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderContainerStyles: styles.accountSettings.titleContainer,
        item: translations.PrivacyPreferences
      }), /*#__PURE__*/React.createElement(PnmacPaper, {
        containerStyles: {
          backgroundColor: "#FFF",
          paddingTop: 20,
          paddingLeft: 25,
          paddingRight: 25,
          paddingBottom: 25,
          marginBottom: 20,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          borderColor: "#efefef",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          elevation: 1,
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "nowrap",
          width: "100%",
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: matches.small ? "60%" : "90%"
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, translations.PrivacyPreferenceOptionOne)), /*#__PURE__*/React.createElement("div", {
        style: {
          width: matches.small ? "40%" : "auto"
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
        onValueChange: function (value) {
          return _this.changeValue(300043, value == "yes" ? 300045 : 300046);
        },
        value: (affiliateMarketingPermission === null || affiliateMarketingPermission === void 0 ? void 0 : affiliateMarketingPermission.preferenceCode) == 300045 ? "yes" : "no"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: matches.small ? 25 : 50,
          display: "flex",
          flexDirection: "row"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.yes), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbAffMarketingPermYes',
        value: "yes"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.no), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbAffMarketingPermNo',
        value: "no"
      })))))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "nowrap",
          width: "100%",
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: matches.small ? "60%" : "90%"
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, translations.PrivacyPreferenceOptionTwo)), /*#__PURE__*/React.createElement("div", {
        style: {
          width: matches.small ? "40%" : "auto"
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
        onValueChange: function (value) {
          return _this.changeValue(300044, value == "yes" ? 300045 : 300046);
        },
        value: (nonAffiliateMarketingPermissions === null || nonAffiliateMarketingPermissions === void 0 ? void 0 : nonAffiliateMarketingPermissions.preferenceCode) == 300045 ? "yes" : "no"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: matches.small ? 25 : 50,
          display: "flex",
          flexDirection: "row"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.yes), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbNonAffMarketingPermYes',
        value: "yes"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.no), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbNonAffMarketingPermNo',
        value: "no"
      })))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HtmlToNative, {
        value: translations.PennymacPrivacyPolicy
      }))), /*#__PURE__*/React.createElement("div", {
        style: styles.accountSettings.buttonContainer
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnPrivacyPreferenceChange',
        style: styles.accountSettings.button,
        disabled: notchanged,
        loading: loading,
        onPress: function () {
          if (parseInt(selectedLoanNumber) > 0) {
            _this.setState({
              loading: true
            });
            var loanPrefs = loanPreference.filter(function (s) {
              return parseFloat(s.loanId) === parseFloat(selectedLoanNumber) && (s.preferenceTypeCode === 300043 || s.preferenceTypeCode === 300044);
            });
            fetch("/api/loan/update_loan_preferences", {
              method: 'POST',
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "Bearer ".concat(_this.props.layout.token)
              },
              body: JSON.stringify(loanPrefs)
            }).then(function (res) {
              return res.json();
            }).then(function (data) {
              if (data) {
                loanPreference.forEach(function (s) {
                  return s.changed = false;
                });
                _this.setState({
                  loading: false,
                  confirmFinal: true,
                  notchanged: true
                });
                _this.setState({
                  loanPreferencePrev: loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.map(function (item) {
                    return __assign({}, item);
                  })
                });
              }
            });
            // Create change log
            var changeLog = _this.createChangeLog(_this.state.loanPreference, _this.state.loanPreferencePrev);
            // You can use the changeLog here for logging purposes
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, changeLog === null || changeLog === void 0 ? void 0 : changeLog.logString, -1, changeLog === null || changeLog === void 0 ? void 0 : changeLog.changes, false);
          }
        }
      }, translations.Change))))) : null;
    });
  };
  return PrivacyPreferences;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPreferences);